import React from 'react';
import './assets/style/style.css';
import './assets/icons/font-awesome/css/all.css';
import { firestore } from './components/firebase/firebase';
import Eventlist from './components/eventlist';
import Event from './components/event';
import { Helmet } from "react-helmet";

class Ppsite extends React.Component {

render() {	
	return (
		<div className="app">
			<Helmet>
				<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
				<meta name="theme-color" content="#f7f7f7" />
			</Helmet>						
			{this.state.initState === 'select' ? <div className="eventlist"><Eventlist eventArray={this.state.eventsList} selectEvent={this.selectEvent} goDemo={this.goDemo} /></div> :null}
			{this.state.initState === 'event' ? <div className="event"><Event cardID={this.state.cardID} eventData={this.state.eventData} getEvents={this.getEvents} /></div> :null}							
			<div className="footer">
				<p>2026 Partypay B.V.</p>
				<div className="conditionContainer">
					<a href="https://partypay.nl/voorwaarden.pdf"><h4>Algemene voorwaarden, verwerkersovereenkomst, SLA</h4></a>
					<a href="https://partypay.nl/privacyverklaring.pdf"><h4>Privacy Policy</h4></a>
				</div>
			</div>		
		</div>
	)
}  
	
constructor(props) {super(props)}	

state = {eventsList: [], eventData: {}, initState: 'select', cardID: ''}

componentDidMount(){
	var searchParams = new URL(window.location.href).searchParams;
	var lastEvent = localStorage.getItem('lastevent');
	var lastVisit = localStorage.getItem('lastvisit');
	if(searchParams.has("id")){
		this.setState({cardID: searchParams.get("id")});
	}
	if(searchParams.has("evt")){
		var evt = searchParams.get("evt");
		if(evt === 'kCPB86QzFWwFbclC2Yle'){evt = '6A1gfTK769sNKyRySbGm'} // Tielse Zomer > Vrienden van Tiel
		if(evt === 'cpdn2XHwK6n7TpUAWJnA'){evt = 'mGdzVq2jDCQ6yPcPH5ne'} // Bruut festival > Bruut afsluiter
		firestore.collection("events").doc(evt).get().then(doc => {var eventData = doc.data(); eventData.eventid = doc.id; this.selectEvent(eventData)});
	}
	else if(searchParams.has("batch")){
		firestore.collection("events").where("cardBatchArray","array-contains",searchParams.get("batch")).limit(1).get().then(snapshot => {if(!snapshot.empty){const doc = snapshot.docs[0]; var eventData = doc.data(); eventData.eventid = doc.id; this.selectEvent(eventData)}else{this.getEvents()}});
	}
	else if(lastEvent && lastVisit && lastVisit < (Math.round(new Date().getTime() / 1000) + 172800)){
		firestore.collection("events").doc(lastEvent).get().then(doc => {var eventData = doc.data(); eventData.eventid = doc.id; this.selectEvent(eventData)});
	}
	else{
		this.getEvents();
	}
	localStorage.setItem('lastvisit', Math.round(new Date().getTime() / 1000));
}

getEvents = () => {
	this.setState({initState: 'select'},()=>{
		firestore.collection("events").where("actief", "==", true).get().then(querySnapshot => {
			if(querySnapshot.size > 0){
				var evlist = [];
				querySnapshot.forEach(doc => {
					var eventData = doc.data();
					eventData.eventid = doc.id;
					evlist.push(...[eventData]);					
				});
				this.setState({eventsList: evlist});
			}
		})
	});
}

selectEvent = (data) => {
	this.setState({eventData: data, initState: 'event'},()=>{window.scrollTo(0, 0)});
	localStorage.setItem('lastevent', data.eventid);
	if(data.webcolor){
		document.querySelector("meta[name='theme-color']")?.setAttribute("content", data.webcolor);
		document.documentElement.style.backgroundColor = data.webcolor;
  		document.body.style.backgroundColor = data.webcolor;  
	}
	else{document.querySelector("meta[name='theme-color']")?.setAttribute("content", '#333333')}
}

goDemo = () => {
	firestore.collection("events").doc('f7b6l3OfJibXBut9f0rb').get().then(doc => {
		var eventData = doc.data();
		eventData.eventid = doc.id;
		this.selectEvent(eventData);
	})
}

formatValue = (value) => {return value.toLocaleString("nl-NL")}

}

export default Ppsite;